import { Injectable } from '@angular/core';

import { Models } from '@ibexfusion/models';
import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class CompositionAppWidgetService extends RestfulService<Models.CompositionAppWidget> {

  constructor(private restService: RestService) {
    super(Models.CompositionAppWidget);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('composition-app-widgets');
  }

}
